var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6045 27.3917L2.15391 24.7069L0.0478516 0.53418H23.1894L21.0812 24.7032L11.6045 27.3917ZM5.13553 14.4406L4.87591 11.4759L15.4273 11.4759L15.6909 8.44006L4.61747 8.44005L4.35414 5.47537L18.8658 5.47537L18.3428 11.4759L18.2722 12.272L17.5477 20.578L11.6186 22.2596L11.6053 22.2638L5.67082 20.578L5.26498 15.923H8.1732L8.37948 18.2875L11.6059 19.179L11.6085 19.1783L14.8397 18.2856L15.1761 14.4406L5.13553 14.4406Z",
    className: "icon-primary-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCss);
export default __webpack_public_path__ + "static/media/icon-css.450bd6cb564c49a21e6abd4ed4a43b32.svg";
export { ForwardRef as ReactComponent };